import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { BsDatepickerConfig } from 'ngx-bootstrap';
import { FormGroup, FormBuilder, AbstractControl } from '@angular/forms';
import { Router } from '@angular/router';
import * as moment from 'moment-timezone';
import { CommonServiceService } from '../../common-service.service';
import { environment } from 'src/environments/environment';
import { GlobalVariable } from '../../global-variable';
import { Store } from '@ngrx/store';
import { InitialState } from 'src/app/store/reducer';
@Component({
  selector: 'app-gstr9-search',
  templateUrl: './gstr9-search.component.html',
  styleUrls: ['../global-search.component.scss']
})
export class Gstr9SearchComponent implements OnInit {
  gstreportFilterForm: FormGroup;
	@ViewChild('searchButton',{static:true}) searchButton : ElementRef;
	minDate = "2023-04-01"
  maxDate = moment().format('YYYY-MM-DD')
  dateFormat = 'YYYY-MM-DD';
  isError: boolean = false;
  showMessage: boolean = false;
  alertType = ''
  fromIndex: any = 0;
	toIndex: any = 30;
  message: string = ``; 
  isLocaleDateFormat: boolean = true;
  constructor(
    public commonService: CommonServiceService,
    private router: Router,
    private formBuilder: FormBuilder,private store: Store<InitialState>) {
      this.store.select('sharedReducers').subscribe((items)=>{
				if(items.financeYear && items.financeYear.start_date && items.financeYear.end_date){
					this.minDate = items.financeYear.start_date
					this.maxDate = this.commonService.getFinancialSession(moment(items.financeYear.end_date)) < this.commonService.getFinancialSession(moment()) ? 
					            moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
				} else {
					let current_financial_year =  JSON.parse(sessionStorage.getItem('current_financial_year'))
					if(!current_financial_year) {
						current_financial_year = JSON.parse(localStorage.getItem('current_financial_year'));
					}
					this.minDate = current_financial_year.start_date
					this.maxDate = this.commonService.getFinancialSession(moment(current_financial_year.end_date)) < this.commonService.getFinancialSession(moment()) ? 
					            moment(items.financeYear.end_date).format('YYYY-MM-DD') : moment().format('YYYY-MM-DD')
				}
				
		})
  }
  ngOnInit() {
    this.gstreportFilterForm = this.formBuilder.group({
      start_date: [this.minDate, this.checkDate('start_date')],
			end_date: [this.maxDate, this.checkDate('end_date')]
    })
    this.setFormData()
    this.getGlobalSettingsFormattedDate();
  }

  checkDate(formControlName){
		return (control: AbstractControl) => {
			let valid = true
			if(!moment(control.value, 'YYYY-MM-DD').isValid()) {
				valid = false
			} else {
				if(this){
					if (moment(control.value).isBefore(moment(this.minDate, 'YYYY-MM-DD')) || moment(control.value).isAfter(moment(this.maxDate, 'YYYY-MM-DD'))) {
						valid = false
					}
				}
			}
			
			return !valid ? {[formControlName]: {value: control.value}} : null;
		};
	}

  setFormData() {
    let queryParams = localStorage.getItem('activeGSTQueryParams')
    if (queryParams != null) {
      let parsedParams = JSON.parse(queryParams)
        this.gstreportFilterForm.controls.start_date.setValue(moment(this.minDate).format('YYYY-MM-DD') )
        this.gstreportFilterForm.controls.end_date.setValue(moment(this.maxDate).format('YYYY-MM-DD'))
    }
  }

  search(values) {
    let queryParams = JSON.parse(JSON.stringify(values))
    console.log("queryParams",queryParams);
    this.commonService.getRequest(`${environment.okountUrl}/reports/gstr9?start_date=${queryParams.start_date}&end_date=${queryParams.end_date}`).subscribe((res:any) =>{
        // let fileName = `GST-REPORT-${Date.now()}.xlsx` 			
        // let blob = new Blob([fileBlob], { 
        //   type: 'application/xlsx'
        // });
        // FileSaver.saveAs(blob, fileName);
        this.showMessage = true;
                this.alertType = 'success-box'
                this.message = 'Download Scheduled Successfully.'
                // this.onNoClickPdfModal()
                setTimeout(() => {
                  this.showMessage = false;
                  let redirectUrl = `${environment.baseAccountUrl}/v2/#/report/schedule-reports/${res.channel_name}`
                  window.open(redirectUrl, '_blank');
                }, 1000)
              }, err => {
                console.log(err)
	   })
  }
    // GlobalVariable.openModalStatus = false;
    // if (values.start_date == null || values.start_date == "" || values.start_date == "Invalid Date" || values.start_date == "Invalid date") {
    //   values.start_date = ""
    // }
    // else {
    //   values.start_date = moment(values.start_date).format('YYYY-MM-DD')
    // }
    // if (values.end_date == null || values.end_date == "" || values.end_date == "Invalid Date" || values.end_date == "Invalid date") {
    //   values.end_date = ""
    // }
    // else {
    //   values.end_date = moment(values.end_date).format('YYYY-MM-DD')
    // }
    // this.router.navigateByUrl(`/display/statutory-report/gst-report/b2b-report?start_date=${values.start_date}&end_date=${values.end_date}`)
    // this.reset()
//   }

  getFilteredData(queryParams) {
    this.commonService.getRequestWithQueryParams(`${environment.okountUrl}/reports/gst`, queryParams).subscribe(res => {
      console.log(res);
    }, err => {
      console.error(err);
    })
  }

  reset() {
    GlobalVariable.openModalStatus = false;
    this.gstreportFilterForm = this.formBuilder.group({
      start_date: [this.minDate],
      end_date: [this.maxDate]
    })
    localStorage.removeItem('activeGSTQueryParams')
  }

  clickSearchButton(){
		this.searchButton.nativeElement.click()
	}

  async getGlobalSettingsFormattedDate() {
		let globalSettingConfig = this.commonService.globalSettingConfig;
		if(!globalSettingConfig || globalSettingConfig.length == 0) {
			globalSettingConfig = await this.commonService.getGlobalSettings();
		}

		let dateConfig = await this.commonService.getDateFormat('date_format')
		this.dateFormat = dateConfig.dateFormat
		this.isLocaleDateFormat = dateConfig.isLocaleDateFormat;
	}
}

